import { render, staticRenderFns } from "./ActivateEmailComponent.vue?vue&type=template&id=60134fdc&"
import script from "./ActivateEmailComponent.vue?vue&type=script&lang=js&"
export * from "./ActivateEmailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports